import { FC } from 'react';
import Style from '../useFormOverview.module.scss';
import { IFormDto, IFormResultDto, IFormResultVersionDto, StudyRoleClaimValue } from 'src/services/api/api-client';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { EditReasonFormHeader } from './EditReasonFormHeader';
import { ReactComponent as EditIcon } from 'src/assets/img/common/edit_20.svg';
import { UE_FORM_TYPE } from 'src/components/expandedRow/records/recordRow';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { useHasStudyClaims } from 'src/helpers/auth/auth-helper';
import { useFormExport } from '../export/FormExport';
import { AppButtonWithTooltip } from 'uikit/buttons/buttonWithTooltip/buttonWithTooltip';
import { isFirstResultVersion } from '../../form-helper';

/**
 *  @deprecated DEPRECATED - we use it only with old study without eCRF feature
 * */
export const OverviewHeader: FC<{
  patientUniqId: string;
  formConfig: IFormDto;
  currentFormResultVersion: IFormResultVersionDto;
  currentFormResult: IFormResultDto;
  stepName?: string;
  onEdit: () => void;
}> = ({ formConfig, currentFormResultVersion, currentFormResult, onEdit, stepName, patientUniqId }) => {
  const { t } = useScopedTranslation('Forms.Overview');
  const { hasStudyClaim } = useHasStudyClaims();
  const study = useStudy();
  const formExporting = useFormExport({
    patientUniqId,
    stepName,
    formResultVersion: currentFormResultVersion,
    formConfig,
  });

  return (
    <div className={Style.modalHeaderContainer}>
      <EditReasonFormHeader
        isUpdated={!isFirstResultVersion(currentFormResultVersion)}
        updatedAt={currentFormResultVersion?.updatedAt}
        editReason={currentFormResultVersion?.editReason}
        updateReasonText={currentFormResultVersion?.updateReasonText}
        editorName={currentFormResultVersion?.doctor?.fullName}
      />

      <div className={Style.modalHeaderRightPart}>
        {currentFormResultVersion?.fillingProgress && (
          <>
            <span>{t('FillingProgress')}</span>
            <span>
              {currentFormResultVersion.fillingProgress.filled}/{currentFormResultVersion.fillingProgress.total}
            </span>
          </>
        )}
        {currentFormResultVersion.isEditable &&
          hasStudyClaim(
            formConfig.type === UE_FORM_TYPE
              ? StudyRoleClaimValue.UeFormEdit
              : currentFormResult.formConfigId === study?.patientFinishingFormId
              ? StudyRoleClaimValue.PatientRelease
              : StudyRoleClaimValue.PatientCreate,
          ) && (
            <AppButtonWithTooltip
              testId={'edit-button'}
              tooltip={t('Edit')}
              Icon={EditIcon}
              variant={'icon-link'}
              colorSchema={'secondary'}
              onClick={() => onEdit()}
            />
          )}

        <div>
          {formExporting.Button}
          {formExporting.Modal}
        </div>
      </div>
    </div>
  );
};
